/** Canonical prod host for NK Our Town (northkingstownri.net). Workers may override via env. */
export const SITE_ORIGIN_FALLBACK = 'https://northkingstownri.net'

export const SITE_NAME = 'NK Our Town'

/** ~156 chars; fits meta description recommendation */
export const DEFAULT_META_DESCRIPTION =
  'North Kingstown RI forum for neighbors: local topics, civic life, schools, events, and shoreline communities. NK Our Town stays civil and useful.'

export const DEFAULT_META_TITLE = 'North Kingstown RI Forum | NK Our Town'

/** Landing page (~53 chars SERP title) */
export const LANDING_META_TITLE = 'North Kingstown RI forums for neighbors | NK Our Town'

/** Landing homepage (~150-158 chars for SERP snippets) */
export const LANDING_META_DESCRIPTION =
  'Neighbor-led forum for North Kingstown, RI: schools, civic life, shoreline, neighborhoods, events, local Q&A on NK Our Town. Browse boards, join civilly.'

export function truncateForMetaDescription(input: string, max = 158): string {
  const cleaned = input.replace(/\s+/g, ' ').trim()
  if (cleaned.length <= max) return cleaned
  const slice = cleaned.slice(0, max - 1)
  const lastSpace = slice.lastIndexOf(' ')
  const base = lastSpace > 40 ? slice.slice(0, lastSpace) : slice
  return `${base}…`
}

/** Target ~58 characters for SERP titles */
export function truncateForMetaTitle(title: string, max = 58): string {
  const cleaned = title.replace(/\s+/g, ' ').trim()
  if (cleaned.length <= max) return cleaned
  const slice = cleaned.slice(0, max - 1)
  const lastSpace = slice.lastIndexOf(' ')
  const base = lastSpace > 24 ? slice.slice(0, lastSpace) : slice
  return `${base}…`
}

export function forumPageTitle(pageTitle: string): string {
  const t = truncateForMetaTitle(pageTitle, 52)
  return `${t} | ${SITE_NAME}`
}

export const GUIDELINES_SEO_TITLE = forumPageTitle('Forum guidelines')

export const GUIDELINES_SEO_DESCRIPTION = truncateForMetaDescription(
  'How we keep NK Our Town useful for North Kingstown RI neighbors: sources for news, respectful commerce posts, protecting student privacy, and moderation expectations.',
)
